/**
 * Exchange Rate Remapper
 * Flutter source: lib/data/models/exchange_rate.dart (fromJson)
 *
 * Maps ExchangeRateDto to ExchangeRateEntity. Fields are 1:1 — kept as
 * an explicit remapper for layer-boundary clarity and future-proofing.
 */
import type { ExchangeRateDto } from '@/data/dtos/payment/exchangeRateDto';
import type { ExchangeRateEntity } from '@/domain/entities/payment/exchangeRateEntity';

export class ExchangeRateRemapper {
  /**
   * Convert DTO to Entity
   */
  static dtoToEntity(dto: ExchangeRateDto): ExchangeRateEntity {
    return {
      rate: dto.rate,
      fee: {
        amount: dto.fee.amount,
        currency: dto.fee.currency,
      },
    };
  }
}
